// Copyright (c) 2017 Deere & Company

import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import actions from '../../actions-list';
import filterOptions from '../constants/filter-options';

export const initializeList = (claims, searchFilters) => ({
    data: sortCollection(searchFilters.sortBy, searchFilters.sortDirection, claims),
    type: actions.UPDATE_TCSM_AUDIT_CLAIM_FILTERED
});

export const updateListFilterBy = (claims, filterBy) =>
    dispatch => {

        dispatch({
            data: filterCollection(filterBy, filterOptions, claims),
            type: actions.UPDATE_TCSM_AUDIT_CLAIM_FILTERED
        });

        dispatch({
            filterBy,
            type: actions.UPDATE_TCSM_AUDIT_CLAIM_FILTER_BY
        });

    };

export const updateListSortBy = (claims, sortBy, sortDirection) =>
    dispatch => {

        dispatch({
            data: sortCollection(sortBy, sortDirection, claims),
            type: actions.UPDATE_TCSM_AUDIT_CLAIM_FILTERED
        });

        dispatch({
            sortBy,
            type: actions.UPDATE_TCSM_AUDIT_CLAIM_SORT_BY
        });

    };

export const updateListSortDirection = (claims, sortBy, sortDirection) =>
    dispatch => {

        dispatch({
            data: sortCollection(sortBy, sortDirection, claims),
            type: actions.UPDATE_TCSM_AUDIT_CLAIM_FILTERED
        });

        dispatch({
            sortDirection,
            type: actions.UPDATE_TCSM_AUDIT_CLAIM_SORT_DIRECTION
        });

    };



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/action-creators/search-filters.js